export default "__VITE_PUBLIC_ASSET__8c3d228c__"